import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import PageHero from '../../components/shared/PageHero';
import Sidebar from '../../components/shared/Sidebar';
import ProgramSearchBlock from './components/ProgramSearchBlock';
import ProgramGrid from './components/ProgramGrid';

export default function Programs() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const searchFilter = searchParams.get('search') || '';

  return (
    <div className="flex flex-col bg-white">
      {/* Page Hero */}
      <PageHero 
        title={searchFilter ? `${t('btn_search_programs')}: ${searchFilter}` : t('programs_title', 'Find a Program')}
        description={t('programs_subtitle', "Discover ESTAD's four pillars of excellence. From high-tech engineering to entrepreneurial leadership, find the path that defines your future.")}
        breadcrumbs={[{ label: t('nav_programs', 'Programs & Courses'), href: '/programs' }]}
        variant="light"
      />

      {/* Program Search Block */}
      <ProgramSearchBlock />

      {/* Main Content with Sidebar */}
      <main className="max-w-7xl mx-auto w-full py-12 md:py-20 px-4 sm:px-6 lg:px-12 flex flex-col lg:flex-row gap-12 lg:gap-16">
        <Sidebar variant="programs" />
        <ProgramGrid searchFilter={searchFilter} />
      </main>

      {/* Bottom CTA Section */}
      <section className="bg-gray-50 py-24 px-6 lg:px-12 border-t border-gray-100">
        <div className="max-w-4xl mx-auto text-center animate-in fade-in slide-in-from-bottom-8 duration-700">
          <h2 className="text-4xl font-black uppercase tracking-tighter mb-6 italic text-navy leading-tight">
            {t('cta_not_sure', 'Not sure which program to choose?')}
          </h2>
          <p className="text-xl text-gray-500 mb-12 font-medium">
            {t('cta_advisors_desc', 'Our academic advisors are here to help you match your passions with the right academic path.')}
          </p>
          <div className="flex flex-wrap justify-center gap-8">
            <button className="bg-navy text-white px-12 py-5 font-black uppercase tracking-widest text-xs hover:bg-navy-light transition-all shadow-xl active:scale-95">
              {t('btn_request_info', 'Request Information')}
            </button>
            <button className="border-2 border-navy text-navy px-12 py-5 font-black uppercase tracking-widest text-xs hover:bg-navy hover:text-white transition-all shadow-sm active:scale-95">
              {t('btn_meet_advisor', 'Meet an Advisor')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
